<template>
    <ul class="option-shape-wrapper">
        <li v-for="(item, index) in data" :key="index">
            {{ item.option_text }}
        </li>
    </ul>
</template>

<script>
export default {
    name: "OptionShape",
    props: ["data"]
};
</script>

<style lang="scss" scoped>
.option-shape-wrapper {
    text-align: right;

    li {
        display: inline-block;
        border: 1px solid #d8e4f0;
        padding: 6px 6px;
        border-radius: 4px;
        background: #fff;
        margin: 0 0 4px 4px;
    }
}
</style>
